import type { Dictionnaire } from '../type';

export const appels: Dictionnaire['appels'] = {
  erreurs: {
    camera: 'Sirocco 无法使用你的相机。',
    micro: 'Sirocco 无法使用你的麦克风。',
    connexion: '无法建立连接。请换一个网络再试。',
    compteOfficiel: '应用官方账号不接听电话。请给它发消息。',
    pasAmi: '你只能给好友打电话。请先添加这位成员。',
    pasAbouti: '通话未能接通。',
    nExistePlus: '这通电话已不存在。',
  },
  natif: {
    pasAbouti: '通话未能接通。',
  },
  ecran: {
    quelquun: '某人',
    personneNaRepondu: '无人接听。',
    pasParti: '电话没能拨出。',
    pasAbouti: '通话未能接通。',
    echanger: '交换两个画面',
    reduire: '缩小通话窗口',
    appel: '通话',
    connexion: '连接中…',
    appelVideo: '视频通话中…',
    appelEnCours: '呼叫中…',
    refuser: '拒绝',
    repondreVideo: '视频接听',
    repondre: '接听',
    accepter: '接受',
    reactiverMicro: '打开麦克风',
    couperMicro: '关闭麦克风',
    montrerCamera: '开启我的摄像头',
    cameraPasOuverte: '无法打开摄像头。',
    rallumerCamera: '重新开启我的摄像头',
    couperCamera: '关闭我的摄像头',
    ecouteur: '切换回听筒',
    hautParleur: '切换到扬声器',
    raccrocher: '挂断',
    entrant: { video: '视频来电…', audio: '来电…' },
    son: (detail: string) => `声音：${detail}`,
    natifMuet: '原生层没有响应',
  },
};
